"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var redirect_exports = {};
__export(redirect_exports, {
  redirect: () => redirect
});
module.exports = __toCommonJS(redirect_exports);
var import_getURL = require("../getURL");
var import_imperative_api = require("../router/imperative-api");
var redirect = function(path, status) {
  if (process.env.VITE_ENVIRONMENT !== "ssr") {
    import_imperative_api.router.navigate(path);
    return;
  }
  var finalPath = path[0] === "/" ? `${(0, import_getURL.getURL)()}${path}` : path;
  return Response.redirect(finalPath, status);
};
//# sourceMappingURL=redirect.js.map
